document.addEventListener('DOMContentLoaded', () => {
  const newsletterPopup = (() => {
    const popup = {
      element: document.querySelector('#newsletter-modal'),

      delay: Number(`
        
        5000
      `),

      cookieTime: Number(`30`),

      show() {
        const modalElement =
          document.querySelector('#newsletter-modal');

        if (modalElement) {
          modalElement.style.display = 'block';
          modalElement.classList.add('active');
          document.body.classList.add('newsletter-open');
        }
      },

      hide() {
        const modalElement =
          document.querySelector('#newsletter-modal');

        if (modalElement) {
          modalElement.style.display = 'none';
          modalElement.classList.remove('active');
          document.body.classList.remove('newsletter-open');
        }
      },

      init() {
        if (!getCookie('popupVisible')) {
          const modalElement =
            document.querySelector('#newsletter-modal');

          if (modalElement) {
            document.body.appendChild(modalElement);

            window.setTimeout(() => {
              popup.show();
            }, popup.delay);

            setCookie(
              'popupVisible',
              'true',
              popup.cookieTime
            );

            // Close button
            const closeBtn =
              modalElement.querySelector(
                '[data-close-newsletter]'
              );

            if (closeBtn) {
              closeBtn.addEventListener(
                'click',
                popup.hide
              );
            }
          }
        }
      },
    };
    const changeFormsByLanguage = () => {
      const toggleForms = () => {
        const getCurrentLocale = () => {
          if (
            window.Shopify &&
            typeof window.Shopify.locale === 'string' &&
            window.Shopify.locale
          ) {
            return window.Shopify.locale.toLowerCase();
          }

          const htmlLang = (
            document.documentElement.getAttribute(
              'lang'
            ) || ''
          ).toLowerCase();

          if (htmlLang) return htmlLang;

          return (
            navigator.language || 'en'
          ).toLowerCase();
        };

        const locale = getCurrentLocale();
        const lang = locale.indexOf('fr') === 0 ? 'fr' : 'en';

        const forms = {
          en: document.querySelector(
            '#newsletter-modal .english-form'
          ),

          fr: document.querySelector(
            '#newsletter-modal .french-form'
          ),
        };

        // Hide all forms
        Object.values(forms).forEach((form) => {
          if (form) {
            form.style.display = 'none';
          }
        });

        // Show current language form
        if (forms[lang]) {
          forms[lang].style.display = 'block';
        } else if (forms.en) {
          // fallback
          forms.en.style.display = 'block';
        }
      };

      toggleForms();

      // Keep forms in sync if locale changes without a full reload.
      const htmlObserver = new MutationObserver(
        (mutations) => {
          for (let i = 0; i < mutations.length; i++) {
            if (
              mutations[i].attributeName ===
              'lang'
            ) {
              toggleForms();
              break;
            }
          }
        }
      );

      htmlObserver.observe(
        document.documentElement,
        {
          attributes: true,
          attributeFilter: ['lang'],
        }
      );
    };

    popup.init();
    changeFormsByLanguage();
  })();

  /**
   * Cookie Helpers
   */

  function setCookie(name, value, days) {
    const date = new Date();

    date.setTime(
      date.getTime() +
        days * 24 * 60 * 60 * 1000
    );

    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();

      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }

    return null;
  }
});